import { render, staticRenderFns } from "./TextAreaSpeller.vue?vue&type=template&id=41c0c8b4"
import script from "./TextAreaSpeller.vue?vue&type=script&lang=js"
export * from "./TextAreaSpeller.vue?vue&type=script&lang=js"
import style0 from "./TextAreaSpeller.vue?vue&type=style&index=0&id=41c0c8b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports